// ============================================================================
//  Normalización de MAC — clave compartida entre presencia y padrón.
//  El firmware `wapsi/lector` manda `id` en minúsculas CON ':' (ej.
//  "cb:20:25:00:00:0b"); el schema de BD (ver src/db/schema.ts) guarda MACs
//  sin separadores, igual que `db.norm_mac` en el piloto Python. Se normaliza
//  UNA vez, en la ingesta (ControlService.onBadgeEvent), así presencia y
//  padrón comparten la misma clave sin volver a tocar esto en cada consulta.
// ============================================================================

/** minúsculas, sin ':' ni '-'. Igual que controlador/app/db.py::norm_mac. */
export function normalizeMac(mac: string): string {
  return (mac ?? '').toLowerCase().replace(/[:-]/g, '').trim();
}

/** Presentación legible (con ':') para pantalla — inverso aproximado de normalizeMac. */
export function formatMac(mac: string): string {
  const clean = normalizeMac(mac);
  const pairs = clean.match(/.{1,2}/g);
  return pairs ? pairs.join(':') : clean;
}
